import { Redirect } from "expo-router"
import { loanAppDashboardPath } from "./utils/LoanUtils"
import { useInfiniteQuery } from "@tanstack/react-query"
import { loanDashboardListInfiniteQueryOptions } from "@/queries/loan-dashboard"
import FullScreenLoader from "@/components/loading/FullScreenLoaderDark"
import { LoanLandingScreen } from "./LoanLandingScreen"

function LoanDashboardIndexScreen() {
  const loanListQuoteQuery = useInfiniteQuery({
    ...loanDashboardListInfiniteQueryOptions("quote"),
  })
  const loanListActiveQuery = useInfiniteQuery({
    ...loanDashboardListInfiniteQueryOptions("active"),
  })
  const loanListRepaidQuery = useInfiniteQuery({
    ...loanDashboardListInfiniteQueryOptions("repaid"),
  })

  if (
    loanListQuoteQuery.isLoading ||
    loanListActiveQuery.isLoading ||
    loanListRepaidQuery.isLoading
  ) {
    return <FullScreenLoader>Loading...</FullScreenLoader>
  }

  const redirectToLoanId =
    loanListQuoteQuery.data?.[0]?.id ||
    loanListActiveQuery.data?.[0]?.id ||
    loanListRepaidQuery.data?.[0]?.id
  if (redirectToLoanId) {
    return <Redirect withAnchor href={loanAppDashboardPath(redirectToLoanId)} />
  }

  return <LoanLandingScreen backButton={false} />
}

export default LoanDashboardIndexScreen
